<template>
  <div v-if="group_by_namespaces || group_by_groups">
    <div v-for="group in groups" :key="group.group_or_namespace">
      <p>{{ group.group_or_namespace }}</p>
      <div class="tile-grid">
        <pipeline-tile
            class="tile"
            v-for="pipeline in group.pipelines"
            :key=pipeline.details.id
            :pipeline=pipeline
            :name=pipeline.projectName
            :show_namespace=false
            :show_namespace_ommitted_group=group_by_groups
            :show_branches=show_branches
            :show_history=show_history
        />
      </div>
    </div>
  </div>
  <div v-else class="tile-grid">
    <pipeline-tile
        class="tile"
        v-for="pipeline in pipelines"
        :key=pipeline.details.id
        :pipeline=pipeline
        :name=pipeline.projectName
        :show_namespace=true
        :show_branches=show_branches
        :show_history=show_history
    />
  </div>
</template>

<script lang="ts">

import PipelineTile from './PipelineTile.vue'
import {Pipeline} from '@/interfaces'

interface PipelineGroup {
  group_or_namespace: string,
  pipelines: Pipeline[],
}

import {defineComponent} from 'vue';

export default defineComponent({
      name: 'PipelineTileGrid',
      components: {
        PipelineTile,
      },
      props: {
        group_by_namespaces: Boolean,
        group_by_groups: Boolean,
        pipelines: Array as () => Pipeline[],
        show_branches: Boolean,
        show_history: Boolean,
      },
      computed: {
        groups(): PipelineGroup[] {
          if (!this.pipelines) {
            return []
          }

          const groups = new Map<string, PipelineGroup>()
          for (const pipeline of this.pipelines) {
            const key: string = this.group_by_groups ? pipeline.namespace.split("/")[0] : pipeline.namespace
            if (groups.has(key)) {
              const group: PipelineGroup | undefined = groups.get(key)
              if (group) {
                group.pipelines.push(pipeline)
              }
            } else {
              groups.set(key, {
                group_or_namespace: key,
                pipelines: [pipeline],
              })
            }
          }

          return Array.from(groups.values())
        }
      }
    }
)
</script>

<style scoped lang="scss">

.tile-grid {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .tile {
    display: flex;
    width: 28rem;
    height: 8rem;
    padding: 0.5rem;
  }
}
</style>
